














































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import DropdownList from '@/commonComponents/dropdownList/dropdownList.vue';
import CustomInput from '@/commonComponents/customInput/customInput.vue';
import ValueEdit from '@/commonComponents/valueEdit/valueEdit.vue';

import * as def from '@/definitions'

import RadioOn from './resources/radioOn.vue';
import ValueDown from './resources/valueDown.vue';
import CheckOn from './resources/checkOn.vue';

import { ResourceHelper } from "@/helper/resourceHelper"
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
      DropdownList,
      CustomInput,
      ValueEdit,
      RadioOn,
      ValueDown,
      CheckOn
  },
})
export default class SettingTable extends Vue 
{
    // 作成タイプ
    private createType = "table";
    // 行
    private row : number = 3;
    // 列
    private column : number = 3;
    // 年
    private year : number = 2018;
    // 月
    private month : number = 12;
    // 開始曜日
    private startDay = "sunday";
    // 曜日の色分け
    private isColorWeekday = true;

    // ドロップダウンリスト
    private isStartDayDropdownActive = false;
    private get startDayDropdownItems()
    {
        var items = new Array();
        items.push({ id : 0, label : "日曜日始まり", isSelected : this.startDay == "sunday" });
        items.push({ id : 1, label : "月曜日始まり", isSelected : this.startDay == "monday" });
        return items;
    }

    private get startDayText()
    {
        var text = "";
        if(this.startDay == "sunday") { text = "日曜日始まり"; }
        else if(this.startDay == "monday") { text = "月曜日始まり"; }
        return text;
    }

    private onClickCreateTable()
    {
        this.createType = "table";
    }

    private onClickCreateCalendar()
    {
        this.createType = "calendar";
    }

    private onClickColorWeekday()
    {
        this.isColorWeekday = !this.isColorWeekday;
    }

    private onClickStartDay()
    {
        this.isStartDayDropdownActive = true;
    }

    private onSelectStartDay(id)
    {
        // 閉じる
        this.isStartDayDropdownActive = false;
        if(id == 0)
        {
            this.startDay = "sunday";        
        }
        else if(id == 1)
        {
            this.startDay = "monday";
        }
    }

    private onChangeValue(value, tag)
    {
        DebugHelper.trace(value)
        if(tag == "row")
        {
            this.row = value;
        }
        else if(tag == "column")
        {
            this.column = value;
        }
        else if(tag == "year")
        {
            this.year = value;
        }
        else if(tag == "month")
        {
            this.month = value;
        }
    }

    private onSetRow(row)
    {
        // 整数化
        this.row = Math.floor(Number(row));
        if(this.row < 1) { this.row = 1; }
    }

    private increaseRow(delta)
    {
        this.row += delta;
        if(this.row < 1) { this.row = 1; }
    }

    private onSetColumn(column)
    {
        // 整数化
        this.column = Math.floor(Number(column));
        if(this.column < 1) { this.column = 1; }
    }

    private increaseColumn(delta)
    {
        this.column += delta;
        if(this.column < 1) { this.column = 1; }
    }

    private onSetYear(year)
    {
        // 整数化
        this.year = Math.floor(Number(year));
        if(this.year < 1900) { this.year = 1900; }
        if(this.year > 2199) { this.year = 2199; }
    }

    private increaseYear(delta)
    {
        this.year += delta;
        if(this.year < 1900) { this.year = 1900; }
        if(this.year > 2199) { this.year = 2199; }
    }

    private onSetMonth(month)
    {
        // 整数化
        this.month = Math.floor(Number(month));
        if(this.month < 1) { this.month = 1; }
        if(this.month > 12) { this.month = 12; }
    }

    private increaseMonth(delta)
    {
        this.month += delta;
        if(this.month < 1) { this.month = 1; }
        if(this.month > 12) { this.month = 12; }
    }

    // 長押し
    private pressed = false;
    private pressedDuration = 0;
    private timers = new Array();

    private resetPress() 
    {
        this.pressed = false;
        this.pressedDuration = 0;
        this.timers.forEach(timer => 
        {
            clearInterval(timer);
        });
    }

    private onPress(propertyName: string, delta: number) 
    {
        this.pressed = true;
        this.timers.push(setInterval(() => 
        {
            if (this.pressed) 
            {
                if (this.pressedDuration > 3)
                {
                    if(propertyName == "row") { this.increaseRow(delta); }
                    else if(propertyName == "column") { this.increaseColumn(delta); }
                    else if(propertyName == "year") { this.increaseYear(delta); }
                    else if(propertyName == "month") { this.increaseMonth(delta); }
                }
                this.pressedDuration++;
            }
        }, 100));
    }

    // プレビュー
    static readonly VIEWBOX_WIDTH = 489;
    static readonly VIEWBOX_HEIGHT = 169;

    private get viewBox()
    {
        // pxと合わせる
        return "0, 0, " + SettingTable.VIEWBOX_WIDTH + "," + SettingTable.VIEWBOX_HEIGHT;
    }

    private get rects()
    {
        var rects = new Array();

        var width = SettingTable.VIEWBOX_WIDTH / this.column;
        var height = SettingTable.VIEWBOX_HEIGHT / this.row;
        for(var r = 0; r < this.row; ++r)
        {
            for(var c = 0; c < this.column; ++c)
            {
                rects.push({ x: c * width, y : r * height, width : width, height : height });
            }
        }

        return rects;
    }

    private onOk()
    {
        // 設定を通知
        this.$emit("set", this.createType, this.row, this.column, this.year, this.month, this.startDay);
        // 閉じる
        this.$emit("close");
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigStyleColor(){
        var style = {
            background : this.userConfigColor
        }
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
